export const usersTypes = {
    SET_USERS: 'SET_USERS',
    NEW_USER: 'NEW_USER',
    SELECT_USER: 'SELECT_USER',
    UNSELECT_USER: 'UNSELECT_USER',
    UPDATE_USER: 'UPDATE_USER',
    REMOVE_USER: 'REMOVE_USER',
    SET_PRINTER: 'SET_PRINTER',
    REMOVE_PRINTER: 'REMOVE_PRINTER',
    SET_CONFIG_PAGE_USERS_SECTION: "SET_CONFIG_PAGE_USERS_SECTION",
    SET_CONFIG_PAGE_SIZE_USERS_SECTION: "SET_CONFIG_PAGE_SIZE_USERS_SECTION",
    SET_CONFIG_SORTED_USERS_SECTION: "SET_CONFIG_SORTED_USERS_SECTION",
    SET_CONFIG_FILTERED_USERS_SECTION: "SET_CONFIG_FILTERED_USERS_SECTION",
    GET_USER_BY_STATIONS: "GET_USER_BY_STATIONS",
}